import React from 'react';
import classnames from 'classnames';
import { StageBackgroundProps } from '../types';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import { useDeviationCoverImage } from '../../../DeviationViews/hooks/useDeviationCoverImage';

import s from './Journal.scss';

const JournalStageBackground: React.FC<StageBackgroundProps> = ({ deviation, width, height }) => {
  const { isFullscreen } = useDeviationViewContext();
  const { coverImage } = useDeviationCoverImage({
    deviation,
    width,
    height,
    allowHuge: true,
  });

  return coverImage ? (
    <BackgroundImage
      src={coverImage.src}
      className={classnames(!isFullscreen && s['background'])}
      imageClassName={s['background-image']}
      fade="full"
    />
  ) : (
    <EmptyBackground className={classnames(!isFullscreen && s['background'])} />
  );
};
JournalStageBackground.displayName = 'JournalStageBackground';

export default JournalStageBackground;
